import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const purchaseWithPurchaseAddProductRolesRBAC = {
  pageID: '2b0080890fd312da0adcfb06b349a602',
  elementID: {
    ViewPage: '54dffb4b57cc929a152376331a4e55f4',
  },
} as const

export const useRBACPurchaseWithPurchaseAddProductPage = createUseRBAC(
  purchaseWithPurchaseAddProductRolesRBAC.elementID,
)

export type UseRBACPurchaseWithPurchaseAddProductPageType = ReturnType<
  typeof useRBACPurchaseWithPurchaseAddProductPage
>
